import React from 'react';

interface ExpertsIconProps {
  className?: string;
  isActive?: boolean;
  size?: number;
}

export const ExpertsIcon: React.FC<ExpertsIconProps> = ({ 
  className = '', 
  isActive = false, 
  size = 16 
}) => {
  const colorClasses = isActive 
    ? 'text-[#72A8FD] group-hover:text-[#8BB8FE]' 
    : 'text-white group-hover:text-gray-200';

  return (
    <svg 
      width={size} 
      height={size * 1.25} // Maintain aspect ratio (16:20)
      viewBox="0 0 16 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={`${colorClasses} transition-colors duration-200 ${className}`}
    >
      <path 
        d="M10.84 14.26C13.86 14.83 16 16.29 16 18V20H0V18C0 16.29 2.14 14.83 5.16 14.26L8 19L10.84 14.26ZM4 6H12V8C12 9.06087 11.5786 10.0783 10.8284 10.8284C10.0783 11.5786 9.06087 12 8 12C6.93913 12 5.92172 11.5786 5.17157 10.8284C4.42143 10.0783 4 9.06087 4 8V6ZM4 5L4.41 0.9C4.46 0.39 4.89 0 5.41 0H10.6C11.11 0 11.54 0.39 11.59 0.9L12 5H4ZM8 1H7V2H6V3H7V4H8V3H9V2H8V1Z" 
        fill="currentColor"
      />
    </svg>
  );
}; 